import { createContext, useContext, useEffect, useState } from 'react'

export const CustomerFormFieldsContext = createContext<{
  failedSubmitCount?: number
}>({})

/**
 * Open state for a collapsible form section. A collapsed section hides its
 * errors, so a failed submit looks like the button does nothing. We reopen a
 * section with errors on every failed submit, even one the user collapsed
 * again after the last attempt.
 */
export const useSectionExpansion = (hasErrors: boolean) => {
  const [isOpen, setIsOpen] = useState(true)
  const { failedSubmitCount } = useContext(CustomerFormFieldsContext)

  // biome-ignore lint/correctness/useExhaustiveDependencies: listed to reopen on every failed submit
  useEffect(() => {
    if (hasErrors) {
      setIsOpen(true)
    }
  }, [hasErrors, failedSubmitCount])

  return {
    isOpen,
    onToggle: () => setIsOpen(!isOpen)
  }
}
